import 'mutationobserver-shim'
import '@babel/polyfill'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import './plugins/axios'
import './plugins/bootstrap-vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
import 'moment/locale/th'
import print from 'vue-print-nb'



import FBSignInButton from 'vue-facebook-signin-button'
Vue.use(FBSignInButton)
Vue.use(VueMoment, {
  moment,
})
Vue.use(print);


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')